import { render, staticRenderFns } from "./CityDetailAbout.vue?vue&type=template&id=4933f64e&scoped=true&"
import script from "./CityDetailAbout.vue?vue&type=script&lang=js&"
export * from "./CityDetailAbout.vue?vue&type=script&lang=js&"
import style0 from "./CityDetailAbout.vue?vue&type=style&index=0&id=4933f64e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4933f64e",
  null
  
)

component.options.__file = "CityDetailAbout.vue"
export default component.exports